import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { ExternalLink, Github } from 'lucide-react';

const Projects = () => {
  const projects = [
    {
      title: 'SkillLink',
      description:
        'Platform connecting skilled individuals without formal degrees to startup job opportunities. Implemented role-based views for job seekers and companies with focus on skill-based hiring.',
      technologies: ['React.js', 'Django', 'MySQL', 'MongoDB'],
      github: 'https://github.com/chandanavadathala',
      demo: '#',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80',
    },
    {
      title: 'Coffee Listing Website',
      description:
        'Coffee shop listing website featuring ratings, reviews, and responsive layout. Built with modern React patterns and clean UI design.',
      technologies: ['React.js', 'CSS', 'JavaScript'],
      github: 'https://github.com/chandanavadathala',
      demo: '#',
      image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=600&q=80',
    },
    {
      title: 'Habit Tracker',
      description:
        'Responsive habit tracking application with real-time progress monitoring, localStorage integration for data persistence, and interactive UI components.',
      technologies: ['React.js', 'JavaScript', 'CSS', 'LocalStorage'],
      github: 'https://github.com/chandanavadathala',
      demo: '#',
      image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=600&q=80',
    },
    {
      title: 'Personal Portfolio Website',
      description:
        'Responsive portfolio website optimized for cross-device compatibility. Features modern design, smooth animations, and clean code structure.',
      technologies: ['HTML', 'CSS', 'JavaScript'],
      github: 'https://github.com/chandanavadathala',
      demo: '#',
      image: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=600&q=80',
    },
  ];

  return (
    <section id="projects" className="py-20 px-6 bg-slate-100/50 dark:bg-slate-900/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            Featured <span className="text-teal-500">Projects</span>
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto rounded-full"></div>
          <p className="text-slate-600 dark:text-slate-400 mt-4 max-w-2xl mx-auto">
            Here are some of my recent projects showcasing my skills in web development
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <Card
              key={index}
              className="overflow-hidden bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] group animate-in fade-in slide-in-from-bottom"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative overflow-hidden h-56">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>

              <div className="p-6">
                <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-3">
                  {project.title}
                </h3>
                <p className="text-slate-600 dark:text-slate-300 mb-4 line-clamp-3">
                  {project.description}
                </p>

                <div className="flex flex-wrap gap-2 mb-4">
                  {project.technologies.map((tech, techIndex) => (
                    <Badge
                      key={techIndex}
                      variant="secondary"
                      className="bg-teal-500/10 text-teal-500 hover:bg-teal-500 hover:text-white transition-colors"
                    >
                      {tech}
                    </Badge>
                  ))}
                </div>

                <div className="flex gap-3">
                  <Button
                    variant="outline"
                    size="sm"
                    className="flex-1 border-teal-500 text-teal-500 hover:bg-teal-500 hover:text-white transition-all"
                    onClick={() => window.open(project.github, '_blank')}
                  >
                    <Github className="mr-2 h-4 w-4" />
                    Code
                  </Button>
                  <Button
                    size="sm"
                    className="flex-1 bg-teal-500 hover:bg-teal-600 text-white transition-all"
                  >
                    <ExternalLink className="mr-2 h-4 w-4" />
                    Demo
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
